import AuthInitializer from '@modules/Auth/components/AuthInitializer';
import { NotificationSocketListener } from '@modules/Notifications';
import { PopupConsumerManager } from '@modules/Popups';
import { AppVersionChecker } from '@shared/components/AppVersionChecker';
import { ThemeProvider } from '@shared/components/ui/theme-provider';
import { Toaster } from '@shared/components/ui/shadcn/toaster';
import { GlobalProgressBar } from '@shared/components/ui/GlobalProgressBar';
import { ZendeskWidget } from '@shared/components/integrations/ZendeskWidget';
import { QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Suspense } from 'react';
import './App.css';
import AppRoutes from './routes/AppRoutes';
import createQueryClient, { bindQueryClientToSession } from './shared/services/queryClient';
import { RadixPortalCloser } from '@shared/components/ui/RadixPortalCloser';

const queryClient = createQueryClient();
bindQueryClientToSession(queryClient);

function App() {
  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <RadixPortalCloser />
        <Suspense>
          <ThemeProvider defaultTheme="light" storageKey="wrh-theme-mode">
            <AppVersionChecker />
            <Toaster />
            <GlobalProgressBar />
            <AuthInitializer>
              <NotificationSocketListener />
              <ZendeskWidget />
              <PopupConsumerManager />
              <AppRoutes></AppRoutes>
            </AuthInitializer>
          </ThemeProvider>
        </Suspense>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
